/*
 *
 * AnalyticsPageRoot
 * (no channel id param given)
 */

import React from "react";
import Helmet from "react-helmet";
import { Wrapper } from "./styledComponents";
import { Title, Button } from "./styledComponents";
import { createStructuredSelector } from "reselect";
import { selectUser } from "../App/selectors";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import H1 from "components/H1";
import { history } from "store";
import { ButtonWrapper } from "../LeadsPage/LeadsList/styledComponents";

import { ButtonLink } from "../../components/Button/ButtonLink";

function AnalyticsRoot({ permissionRole }) {

  return (
    <Wrapper>
      <Helmet title="Movebooth | Analytics" />
      <Title>
        <H1>Analytics</H1>
        <Button className="cancel" onClick={() => history.push("/channels")}>
          Back to Channels
        </Button>
      </Title>
      <div style={{ marginTop: "3em" }}>
        {permissionRole ? permissionRole === "lite" ? (
          <ButtonWrapper>
            <ButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to access analytics for my channel!">
              Upgrade to PLUS for Analytics
            </ButtonLink>
          </ButtonWrapper>
        ) : (
          <p style={{ textAlign: "center" }}>
            Select the Analytics link in the Channels dropdown menu to view a specific channel's analytics.
          </p>
        ) : null}
      </div>
    </Wrapper>
  );
}

const mapStateToProps = createStructuredSelector({
  user: selectUser(),
  permissionRole: (state) => state.app.user.permission_role,
});

export default connect(mapStateToProps)(withRouter(AnalyticsRoot));



// WEBPACK FOOTER //
// ./src/containers/AnalyticsPage/AnalyticsRoot.js